var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeCatalog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8EECF534-D1AC-4A40-AB50-CDB1C61053CB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-V3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Schedule-Cards",
    transform: "translate(-76.000000, -126.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-Cataloging",
    transform: "translate(56.000000, 106.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-catalog-icon",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)",
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,0 C15.1045695,0 16,0.8954305 16,2 L16,14 C16,15.1045695 15.1045695,16 14,16 L2,16 C0.8954305,16 0,15.1045695 0,14 L0,2 C0,0.8954305 0.8954305,0 2,0 L14,0 Z M14,1 L2,1 C1.4728191,1 1.04091744,1.4079389 1.00274287,1.92536883 L1,2 L1,14 C1,14.5271809 1.4079389,14.9590826 1.92536883,14.9972571 L2,15 L14,15 C14.5271809,15 14.9590826,14.5920611 14.9972571,14.0746312 L15,14 L15,2 C15,1.4728191 14.5920611,1.04091744 14.0746312,1.00274287 L14,1 Z M12.5,10.5 C12.7761424,10.5 13,10.7238576 13,11 C13,11.2564179 12.8069799,11.4677536 12.5583106,11.4966361 L12.5,11.5 L3.5,11.5 C3.22385763,11.5 3,11.2761424 3,11 C3,10.7435821 3.1930201,10.5322464 3.44168944,10.5033639 L3.5,10.5 L12.5,10.5 Z M12.5,7.5 C12.7761424,7.5 13,7.72385763 13,8 C13,8.25641792 12.8069799,8.46775358 12.5583106,8.49663613 L12.5,8.5 L3.5,8.5 C3.22385763,8.5 3,8.27614237 3,8 C3,7.74358208 3.1930201,7.53224642 3.44168944,7.50336387 L3.5,7.5 L12.5,7.5 Z M12.5,4.5 C12.7761424,4.5 13,4.72385763 13,5 C13,5.25641792 12.8069799,5.46775358 12.5583106,5.49663613 L12.5,5.5 L3.5,5.5 C3.22385763,5.5 3,5.27614237 3,5 C3,4.74358208 3.1930201,4.53224642 3.44168944,4.50336387 L3.5,4.5 L12.5,4.5 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCatalog);
export default __webpack_public_path__ + "static/media/home-catalog.f0b5933bfe7ea188f1c8973defa5844e.svg";
export { ForwardRef as ReactComponent };